// assets/js/vendor.js
import utilitiesAll from './utilities/utilitiesAll';
// 初期化
document.addEventListener('DOMContentLoaded', async () => {
  try {
    await utilitiesAll();
  } catch (error) {
    console.error("Error initializing utilities:", error);
  }
});
